module.exports = __webpack_public_path__ + "vue_assets/img/img_timeline.282f0f2a.webp";